// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__2rlvl"};